import React, {useEffect, useState, useContext, useRef, useCallback} from "react";
import ReactPlayer from "react-player";
import Navbar from "./Navbar"; // Ensure this import is correct
import "./App.css";
import { useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "./ContextVars"; // #added para #testmode 20/7/25 TG
import translations from './translations';

const HomePage = () => { // #added 28/3/25 TG

    const navigate = useNavigate();
    const location = useLocation(); // #added 29/3/25 TG
    const currentVersion = "29.3.25.TG"; // #added 29/3/25 TG
    const [clickCount, setClickCount] = useState(0); // #added #testmode 20/7/25 TG
    const {setTestMode, language} = useContext(AppContext);
    const t = (key) => translations.HomePage[key]?.[language] || key;

    const sectionRef = useRef(null);
    const contentRef = useRef(null);
    const [contentScale, setContentScale] = useState(1);

    // #added 9/6/25 TG: Auto-scale program content to fit within 90% of the video section
    const updateContentScale = useCallback(() => {
      const section = sectionRef.current;
      const content = contentRef.current;
      if (!section || !content) return;
  
      const sectionHeight = section.clientHeight;
      const contentHeight = content.scrollHeight;
      const maxContentHeight = sectionHeight * 0.9;
  
      if (contentHeight > maxContentHeight) {
        setContentScale(maxContentHeight / contentHeight);
      } else {
        setContentScale(1);
      }
    }, []);
  
    useEffect(() => {
      const section = sectionRef.current;
      const content = contentRef.current;
      if (!section || !content) return;
  
      updateContentScale();
  
      const observer = new ResizeObserver(() => {
        updateContentScale();
      });
  
      observer.observe(section);
      observer.observe(content);
  
      return () => observer.disconnect();
    }, [updateContentScale]);

    const handleAppClick = () => {
        window.location.href = "https://eleven.fit/timer/workouts";
    };

    useEffect(() => { // #added 29/3/25 TG
        if (location.hash) {
          const sectionId = location.hash.replace("#", ""); // Remove the #
          const section = document.getElementById(sectionId);
          if (section) {
            section.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, [location]);

      useEffect(() => {
        console.log("current version: " + currentVersion);
      }, []);

      const countTestClick = () => {
        setClickCount(clickCount+1);
        if (clickCount >= 7) {
          setTestMode(true);
        }
      }

      //------------------------------------
      // JSX TG
      //------------------------------------

  return (
    <div>
      {/* <Navbar /> */}
      <main>

        {/* Main Welcome Section */}
        <section id="home" className="section">
          <div className="section__content">
            <h2 className="home-subtitle">{t('welcome')}</h2>
            <h1 className="home-title" onClick={countTestClick}>Eleven.fit</h1>
          </div>
        </section>

        {/* #Program Section */}
        <section id="program" className="section" ref={sectionRef}>
          <div className="video-container">
            <ReactPlayer
              url="https://www.youtube.com/watch?v=6P7Ngrsplw8"
              playing
              loop
              muted
              controls={false}
              width="100%"
              height="100%"
              className="react-player"
            />
          </div>
          <div className="section__content">
            <div className="program-content" ref={contentRef} style={{ transform: `scale(${contentScale})`, transformOrigin: 'center center' }}>
              <h2 className="program-title width-50 move-left">
                {t('programTitle')}
              </h2>
              <div className="program-description max-width-700px move-left">
                {t('programDesc')}
              </div>
              <button className="button-2 move-left margin-top-10" onClick={() => navigate("/functional")}>
                {t('tellMeMore')}
              </button>
            </div>
          </div>
        </section>

        {/* #App */}
        <section id="app" className="section overlay tint-black-50">
          <div className="section__content">
            <div className="gdiv width-80 gap-10px">
              <h2 className="general-title text-align-right move-right text-shadow">
                {t('appTitle')}
              </h2>
              <div className="general-description text-align-right move-left text-shadow">
                {t('appDesc')}
              </div>
              <button className="button-2 move-right margin-top-10" onClick={handleAppClick}>
                {t('goToApp')}
              </button>
            </div>
          </div>
        </section>

        {/* #Who Am I */}
        <section id="who-am-i" className="section">
          <div className="section__content">
            <div className="gdiv width-80 gap-10px">
              <h2 className="general-title text-align-left move-left text-shadow">
                {t('whoAmITitle')}
              </h2>
              <div className="general-description text-align-left move-left text-shadow">
                {t('whoAmIDesc')}
              </div>
              <button className="button-2 move-left margin-top-10" onClick={() => navigate("/about")}>
                {t('moreInfo')}
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default HomePage;